import * as React from "react";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import { Row } from "common/components/layout-styles";
import useAssetPanel from "security-app/components/Assets/hooks/useAssetPanel";
import AssetDetailsOverlay from "security-app/components/Assets/plugin/AssocAssetsWidget/AssetDetailsOverlay";
import useFieldActions from "views/components/actions/useFieldActions";
function SidebarAssetLink({ asset, noIcon = false }) {
  const { openAssetDetails } = useAssetPanel();
  return /* @__PURE__ */ React.createElement(Row, { $gap: "xxs", $align: "center" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: () => openAssetDetails(asset) }, asset.name), !noIcon && /* @__PURE__ */ React.createElement(Icon, { name: "arrow_right", size: "sm" }));
}
function AssetLink({ asset, noIcon = false }) {
  const fieldActionsContext = useFieldActions();
  if (fieldActionsContext == null ? void 0 : fieldActionsContext.assetDetailsActions) {
    return /* @__PURE__ */ React.createElement(AssetDetailsOverlay, { asset, assetDetailsActions: fieldActionsContext == null ? void 0 : fieldActionsContext.assetDetailsActions });
  }
  return /* @__PURE__ */ React.createElement(SidebarAssetLink, { asset, noIcon });
}
export default AssetLink;
